export const menuItems = [
  
 
  {
    name: "Comparatifs Banques Pro",
    label: "Comparatifs Banques Pro",
    items: [
      { name: "banque-pro/sas-sasu/", label: "SAS/SASU" },
      { name: "banque-pro/eurl-sarl/", label: "SARL/EURL" },
      { name: "banque-pro/auto-entrepreneurs/", label: "Auto-Entrepreneurs" },
      { name: "banque-pro/association/", label: "Associations" },
      { name: "banque-pro/sci/", label: "SCI" },
      { name: "banque-pro/restaurant/", label: "Restaurants" },
      { name: "banque-pro/startup/", label: "Startup" },
      { name: "banque-pro/depot-capital/", label: "Dépôt de Capital" },
    ],
  },
  {
    name: "Avis Banques Pro",
    label: "Avis Banques Pro",
    items: [
      { name: "banque-pro/avis-anytime/", label: "Avis Anytime" },
      { name: "banque-pro/avis-manager-one/", label: "Avis Manager.one" },
      { name: "banque-pro/avis-qonto/", label: "Avis Qonto" },
      { name: "banque-pro/avis-shine/", label: "Avis Shine" },
    ],
  },
  
 
 
   
      // { name: "find-an-investor/", label: `Find an Investor 🔥` },
         
        
  
     
  
      




     
  

 
  // {
  //   name: "pages",
  //   label: "Pages",
  //   items: [
  //     { name: "about", label: "About" },
  //     {
  //       name: "career",
  //       label: "Career",
  //       items: [
  //         { name: "career", label: "Career List" },
  //         { name: "career-details", label: "Career Details" },
  //       ],
  //     },
  //     {
  //       name: "case-study",
  //       label: "Case Study",
  //       items: [
  //         { name: "case-study", label: "Case Study" },
  //         { name: "case-study-details", label: "Case Study Details" },
  //       ],
  //     },
  //     {
  //       name: "blog",
  //       label: "Blog",
  //       items: [
  //         { name: "blog-regular", label: "Blog Regular" },
  //         { name: "blog-left-sidebar", label: "Blog Left Sidebar" },
  //         { name: "blog-right-sidebar", label: "Blog Right Sidebar" },
  //         { name: "blog-details", label: "Blog Details" },
  //       ],
  //     },
  //     {
  //       name: "contact",
  //       label: "Contact",
  //       items: [
  //         { name: "contact-1", label: "Contact 01" },
  //         { name: "contact-2", label: "Contact 02" },
  //         { name: "contact-3", label: "Contact 03" },
  //       ],
  //     },
  //     {
  //       name: "account",
  //       label: "Account",
  //       items: [
  //         { name: "signin", label: "Signin" },
  //         { name: "signin-bg", label: "Signin BG" },
  //         { name: "signup", label: "Signup" },
  //         { name: "signup-bg", label: "Signup BG" },
  //         { name: "reset-pass", label: "Reset Password" },
  //         { name: "reset-pass-bg", label: "Reset Password BG" },
  //       ],
  //     },
  //     {
  //       name: "pricing",
  //       label: "Pricing",
  //       items: [
  //         { name: "pricing-1", label: "Pricing 01" },
  //         { name: "pricing-2", label: "Pricing 02" },
  //       ],
  //     },
  //     {
  //       name: "utility",
  //       label: "Utility",
  //       items: [
  //         { name: "coming-soon", label: "Coming Soon" },
  //         { name: "coming-soon-2", label: "Coming Soon 02" },
  //         { name: "404", label: "404 Page" },
  //         { name: "thank-you", label: "Thank You" },
  //         { name: "terms-conditions", label: "Terms & Conditions" },
  //       ],
  //     },
  //     {
  //       name: "essential",
  //       label: "Essential",
  //       items: [
  //         { name: "faq", label: "FAQ" },
  //         { name: "reviews", label: "Reviews" },
  //       ],
  //     },
  //   ],
  // },
  
];
